// extracted by mini-css-extract-plugin
export default {"CardStack":"CardStack_CardStack__cZoRX","CardStack--columns":"CardStack_CardStack--columns__jguIo"};